<script>
  import { AppState } from '../../etc/stores';
  const { textAboveBackground } = $AppState.theme.colors;

  export let width = 16;
  export let height = 16;
  export let color = textAboveBackground;
</script>

<svg
  {width}
  {height}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M1.6665 8L14.3328 8"
    stroke={color}
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M9.6665 3.33398L14.3332 8.00065L9.6665 12.6673"
    stroke={color}
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
